import { styled } from "@mui/material"

const FlexDiv = styled("div", { shouldForwardProp: false })`
  display: flex;
  align-items: center;
`

export default FlexDiv
